module.exports = __webpack_public_path__ + "static/media/1.6_preview.a65ab252.png";